import Layout from '@/components/layout/Index'
import EmptyView from '@/views/EmptyView'

export default [
  {
    path: '/applications',
    name: 'applications',
    component: Layout,
    children: [
      {
        path: 'combination',
        component: EmptyView,
        meta: { title: '组价数据库', icon: 'home', noCache: true, keepAlive: false, auth: true },
        children: [
          {
            path: 'manage',
            component: () => import('@/views/CommonView.vue'),
            redirect: '/database/manage/configTask',
            meta: { title: '权限设置', icon: 'home', noCache: true, keepAlive: false, auth: true },
            children: [
              {
                path: 'configTask',
                // component: () => import('@/views/database/children/manage/ConfigTask.vue'),
                component: () => import('@/views/upgrade'),
                meta: { title: '分配审核任务', icon: 'home', noCache: true, keepAlive: false, auth: true }
              },
              {
                path: 'setPrivilege',
                component: () => import('@/views/database/children/manage/SetPrivilege.vue'),
                meta: { title: '设置免审核人员', icon: 'home', noCache: true, keepAlive: false, auth: true }
              }
            ]
          }
        ]
      },
      // {
      //   path: 'manage',
      //   component: () => import('@/views/CommonView.vue'),
      //   redirect: '/database/manage/configTask',
      //   meta: { title: '权限设置', icon: 'home', noCache: true, keepAlive: false, auth: false },
      //   children: [
      //     {
      //       path: 'configTask',
      //       component: () => import('@/views/database/children/manage/ConfigTask.vue'),
      //       meta: { title: '分配审核任务', icon: 'home', noCache: true, keepAlive: false, auth: false }
      //     },
      //     {
      //       path: 'setPrivilege',
      //       component: () => import('@/views/database/children/manage/SetPrivilege.vue'),
      //       meta: { title: '设置免审核人员', icon: 'home', noCache: true, keepAlive: false, auth: false }
      //     }
      //   ]
      // },
      // {
      //   path: 'price', // 企业价格库  R2 第二迭代 废弃 ...
      //   name: 'applications_price',
      //   component: () => import('@/views/CommonView.vue'),
      //   meta: { title: '企业价格库', icon: 'home', noCache: true, keepAlive: false, auth: false }
      // },
      // {
      //   path: 'norm', // 指标数据  R2 第二迭代 废弃 ...
      //   name: 'applications_norm',
      //   component: () => import('@/views/CommonView.vue'),
      //   meta: { title: '指标数据', icon: 'home', noCache: true, keepAlive: false, auth: false }
      // },
      // {
      //   path: 'inventory', // 企业清单  R2 第二迭代 废弃 ...
      //   name: 'applications_inventory',
      //   component: () => import('@/views/CommonView.vue'),
      //   meta: { title: '企业清单', icon: 'home', noCache: true, keepAlive: false, auth: false }
      // },
      {
        path: 'home', // 企业级数据库首页
        name: 'applications_home',
        component: () => import('@/views/applications/Home.vue'),
        meta: { title: '企业数据库', icon: 'home', noCache: true, keepAlive: false, auth: true }
      },
      {
        path: 'iframe', // 企业数据库 嵌入页面
        name: 'applications_iframe',
        component: () => import('@/views/applications/Iframe.vue'),
        meta: { title: '企业数据库', icon: 'home', noCache: true, keepAlive: false, auth: true }
      }
    ]
  }
]
